import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    SimpleChanges,
} from '@angular/core';
import { IImage } from '@core/interfaces/booking.interface';
import { SignedUrlPipe } from '@core/pipes/signed-url.pipe';

@Component({
  selector: 'app-program-photos',
  imports: [CommonModule, SignedUrlPipe],
  templateUrl: './program-photos.component.html',
  styleUrl: './program-photos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramPhotosComponent {
  @Input() public teamImages: IImage[] = [];
  @Input() public clinicImages: IImage[] = [];
  public mainImage: IImage = { key: '', path: '' };
  
  constructor(private readonly cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.updateImages();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['clinicImages'] || changes['teamImages']) {
      this.updateImages();
      this.cdr.markForCheck();
    }
  }

  private updateImages(): void {
    if (this.clinicImages.length > 0) {
      this.mainImage = this.clinicImages[0];
    } else if (this.teamImages.length > 0) {
      this.mainImage = this.teamImages[0];
    } else {
      this.mainImage = { key: '', path: '' };
    }
  }
}
